module.exports = __webpack_public_path__ + "static/media/178.066d75ae.jpg";